export function formatFiatCurrency(value: number): string {
  if (
    value == undefined ||
    value == null ||
    isNaN(value) ||
    !isFinite(value) ||
    value === 0
  ) {
    return "0";
  }
  return (+value)
    .toFixed(2)
    .replace(/\.?0+$/, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function formatCryptoCurrency(value: number): string {
  if (
    value == undefined ||
    value == null ||
    isNaN(value) ||
    !isFinite(value) ||
    value === 0
  ) {
    return "0";
  }
  let str = (+value).toFixed(9);
  str = str.substring(0, str.length - 1).replace(/\.?0+$/, "");
  return str;
}
